<template>
    <InlineSvg
        :src="resolvedSrc"
        :class="this.class"
    />
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
    components: { InlineSvg },
    props: {
        dir: {
            type: String,
            require: false,
            default: "/icons/icon-selector/"
        },
        name: {
            type: String,
            require: true,
            value: ''
        },
        class: {
            type: String,
            require: false,
            value: ''
        }
    },
    data() {
        const baseName = this.name ? this.name.replace(/-fill$/, '') : '';
        return {
            resolvedSrc: `${this.dir}${baseName}.svg`
        };
    },
    computed: {
        sanitizedName() {
            return this.name ? this.name.replace(/-fill$/, '') : '';
        }
    },
    watch: {
        name() {
            this.updateSrc();
        },
        dir() {
            this.updateSrc();
        }
    },
    mounted() {
        this.updateSrc();
    },
    methods: {
        updateSrc() {
            const baseUrl = `${this.dir}${this.sanitizedName}.svg`;
            this.resolvedSrc = baseUrl;
            //this.resolveSrc();
        },
        async resolveSrc() {
            const baseName = this.sanitizedName;
            if (!baseName) return;
            const fillUrl = `${this.dir}${baseName}-fill.svg`;
            const baseUrl = `${this.dir}${baseName}.svg`;
            try {
                const res = await fetch(fillUrl, { method: 'HEAD' });
                this.resolvedSrc = res && res.ok ? fillUrl : baseUrl;
            } catch (e) {
                this.resolvedSrc = baseUrl;
            }
        }
    }
};
</script>
